/* ==========================================================================
   Gourmet Mallorca — Geschenk-Automatik für die Influencer-Aktion
   Datei: assets/gm-gift.js

   VORAUSSETZUNG
   Das Geschenkprodukt steht auf 0,00 €. Es braucht deshalb KEINEN Rabatt,
   um kostenlos zu sein. Damit entfällt die fehleranfällige Mechanik, den
   Rabattcode zur richtigen Zeit in die Sitzung zu bekommen.

   EINBAU
   1. Themes → Code bearbeiten → assets → gm-gift.js anlegen
   2. In layout/theme.liquid direkt vor </body>:
      ZUERST das Strings-Objekt, DANN das Skript:
      {% render 'gm-gift-strings' %}
      <script src="{{ 'gm-gift.js' | asset_url }}" defer></script>

   SPRACHEN
   Asset-JS wird von Shopify NICHT durch Liquid gerendert — `| t` gibt es
   hier also nicht. Alle sichtbaren Texte und der Sprach-Wurzelpfad kommen
   deshalb aus dem Objekt window.gmGift, das das Snippet
   snippets/gm-gift-strings.liquid vor diesem Skript ausgibt. Fehlt das
   Snippet, greifen die deutschen Rückfallwerte in T() unten — das Skript
   bleibt also funktionsfähig, nur einsprachig.

   WAS ES TUT
   - Blendet im Warenkorb und im Drawer ein Feld für den Rabattcode ein.
     Die Eingabe wechselt die Seite NICHT — der Code wird im Hintergrund
     hinterlegt und das Geschenk sofort eingelegt
   - Legt das Geschenk nur dann in den Warenkorb, wenn der Aktionscode
     eingegeben oder der Aktionslink benutzt wurde
   - Nimmt es wieder heraus, wenn der Warenkorb darunter fällt
   - Akzeptiert es, wenn der Kunde das Geschenk selbst entfernt
   - Hinterlegt eine Notiz an der Bestellung, damit die Zuordnung zur
     Influencerin auch dann steht, wenn der Rabattcode verloren geht

   DIE AKTIONSLINKS
   MILEIKI     https://gourmet-mallorca.com/discount/MILEIKI?redirect=%2F%3Fgm_gift%3DMILEIKI
   DANKE       https://gourmet-mallorca.com/discount/DANKE?redirect=%2F%3Fgm_gift%3DDANKE
   WILLKOMMEN  https://gourmet-mallorca.com/discount/WILLKOMMEN?redirect=%2F%3Fgm_gift%3DWILLKOMMEN
   LAUNCH      https://gourmet-mallorca.com/discount/LAUNCH?redirect=%2F%3Fgm_gift%3DLAUNCH
   HOLA        https://gourmet-mallorca.com/discount/HOLA?redirect=%2F%3Fgm_gift%3DHOLA
   FRIASOPHIA   https://gourmet-mallorca.com/discount/FRIASOPHIA?redirect=%2F%3Fgm_gift%3DFRIASOPHIA
   HOUSEOFIVY   https://gourmet-mallorca.com/discount/HOUSEOFIVY  (nur versandkostenfrei ab 70 EUR, kein Geschenk)
   Der Code laesst sich auch einfach ins Feld im Warenkorb tippen.

   MENGE
   Das Geschenk ist auf 1 Stueck je Bestellung begrenzt. Wer im Warenkorb
   auf „+" drueckt, wird automatisch auf 1 zurueckgesetzt.

   EINMAL PRO KUNDE
   Das Geschenk gibt es je Code nur EINMAL pro Browser. Sobald der
   Warenkorb, in dem es lag, abgeschlossen ist (Shopify vergibt dann ein
   neues Warenkorb-Token), wird der Code als verbraucht vermerkt — ohne
   Ablauf. Die ZUORDNUNG fuer die Provision bleibt davon unberuehrt und
   laeuft weiter ueber days bzw. FLAG_DAYS.
   Zuruecksetzen fuer Tests: ?gm_gift=0 loescht auch die Verbrauchsliste.

   ZUM TESTEN
   Die Freischaltung liegt dreißig Tage im Browser. Wer den Link einmal
   benutzt oder den Code eingegeben hat, bekommt das Geschenk deshalb
   auch bei allen weiteren Besuchen — auch ohne Link. Zum Zurücksetzen:
   gourmet-mallorca.com/?gm_gift=0
   Oder ein privates Fenster benutzen.
   ========================================================================== */

(function () {
  'use strict';

  /* ── Sprache ──────────────────────────────────────────────────────
     window.gmGift kommt aus snippets/gm-gift-strings.liquid. Fehlt es,
     laeuft alles auf Deutsch weiter. */
  var GM = window.gmGift || {};
  var STR = GM.strings || {};

  function T(key, fallback) {
    return (typeof STR[key] === 'string' && STR[key].length) ? STR[key] : fallback;
  }

  /* Sprach-Wurzelpfad: "" in der Hauptsprache, "/en" in der Zweitsprache.
     Wird NUR fuer Seitenpfade gebraucht (z. B. die Erkennung der
     Warenkorbseite), NICHT fuer die AJAX-Endpunkte. */
  var ROOT = (typeof GM.root === 'string') ? GM.root.replace(/\/$/, '') : '';

  /* WICHTIG — die Warenkorb-API laeuft IMMER ohne Sprachpraefix.
     Shopify fuehrt pro Sitzung genau EINEN Warenkorb, sprachuebergreifend.
     Ein Aufruf von /en/cart/add.js wird auf /cart/add.js umgeleitet, und
     bei einer Umleitung wird aus dem POST ein GET — die Anfrage kommt
     also ohne Inhalt an und legt nichts in den Korb. Genau das war der
     Grund, warum das Geschenk auf /en/ nicht erschien.
     Dasselbe gilt fuer /discount/<code>. */
  function url(path) { return path; }

  /* ── Einstellungen ────────────────────────────────────────────────── */

  /* Aktionen. Jede Zeile ist ein Code mit eigener Schwelle und eigenem
     Geschenk. Neue Aktion = eine Zeile mehr, sonst nichts.
       code      — was der Kunde eingibt (Groß-/Kleinschreibung egal)
       threshold — Mindestbestellwert in Cent
       gift      — Varianten-ID des Geschenks, NICHT die Produkt-ID
       days      — optional: wie lange die ZUORDNUNG im Browser bleibt.
                   Ohne Angabe gilt FLAG_DAYS. Wichtig fuer Provision:
                   Wer ueber den Link kommt, kauft selten sofort.
                   Das GESCHENK ist davon unabhaengig und immer nur
                   einmal pro Browser einloesbar. */
  var CAMPAIGNS = [
    { code: 'MILEIKI',    threshold: 10000, gift: 58084397089151, days: 30 },
    { code: 'DANKE',      threshold: 10000, gift: 58084397089151 },
    { code: 'WILLKOMMEN', threshold: 10000, gift: 58084397089151 },
    { code: 'LAUNCH',     threshold: 10000, gift: 58084397089151 },
    { code: 'HOLA',       threshold: 10000, gift: 58084397089151 },
    { code: 'UEBERBLICK', threshold: 10000, gift: 58084397089151 },
    { code: 'FRIASOPHIA',  threshold: 10000, gift: 58084397089151 },
    /* Bodega-Codes und A Walk on the Wine Side (3.11.2026) */
    { code: 'SONPUIG', threshold: 10000, gift: 58084397089151 },
    { code: 'SONVICH', threshold: 10000, gift: 58084397089151 },
    { code: 'SANTACATARINA', threshold: 10000, gift: 58084397089151 },
    { code: 'VINSNADAL', threshold: 10000, gift: 58084397089151 },
    { code: 'SESTALAIOLES', threshold: 10000, gift: 58084397089151 },
    { code: 'VINYATAUJANA', threshold: 10000, gift: 58084397089151 },
    { code: 'MESQUIDAMORA', threshold: 10000, gift: 58084397089151 },
    { code: 'SONGRAUGRAN', threshold: 10000, gift: 58084397089151 },
    { code: 'CASAPADRINA', threshold: 10000, gift: 58084397089151 },
    { code: 'KARRETANIA', threshold: 10000, gift: 58084397089151 },
    { code: 'SESROTES', threshold: 10000, gift: 58084397089151 },
    { code: 'SONJULIANA', threshold: 10000, gift: 58084397089151 },
    { code: 'SONPRIM', threshold: 10000, gift: 58084397089151 },
    { code: 'MIQUELGELABERT', threshold: 10000, gift: 58084397089151 },
    { code: 'SACABANA', threshold: 10000, gift: 58084397089151 },
    { code: 'AWALKONTHEWINESIDE', threshold: 10000, gift: 58084397089151 }
  ];

  /* Weitere gueltige Shopify-Codes OHNE Geschenk, z. B. Versandrabatt.
     Sie loesen beim Klick auf Zur Kasse keine Warnung Code unbekannt aus. */
  var OTHER_CODES = ['HOUSEOFIVY', 'FAMILY04', 'FRIENDS04', 'ABHOLUNG'];
  function isOtherCode(value) {
    return OTHER_CODES.indexOf(String(value || '').toUpperCase()) !== -1;
  }

  // Notiz, die an der Bestellung hängt — der Wert ist der jeweilige Code
  var ATTR_KEY = 'Empfehlung';

  // Gültigkeit der Markierung in Tagen
  var FLAG_DAYS = 30;

  // Auf der Warenkorb-SEITE muss neu geladen werden, damit die neue Zeile
  // erscheint — sie wird serverseitig gerendert. Im Drawer nicht, der
  // zeichnet sich selbst neu. Auf false setzen, wenn gar nicht neu
  // geladen werden soll; das Öl erscheint dann erst beim nächsten Aufruf.
  var RELOAD_ON_CART_PAGE = true;

  // Beschriftungen des Eingabefelds
  /* true = das Codefeld steht offen im Warenkorb, mit Rahmen und
     Hintergrund. Kunden übersehen den eingeklappten Link sonst und
     versuchen den Code im Checkout — dort greift die Geschenk-Automatik
     nicht mehr. Auf false setzen, wenn wieder eingeklappt werden soll. */
  var FIELD_ALWAYS_OPEN = true;

  /* Alle sichtbaren Texte. Der zweite Wert ist der deutsche Rueckfall,
     falls das Strings-Snippet fehlt. Platzhalter %min% und %missing%
     statt {0}/{1} — geschweifte Klammern koennen in Locale-Werten
     stehen, aber der Einheitlichkeit halber gilt ueberall %…%. */
  var TXT_LABEL = T('label', 'Aktions- oder Rabattcode');
  var TXT_HINT = T('hint', 'Nicht erst an der Kasse eingeben.');
  var TXT_TOGGLE = T('toggle', 'Rabattcode einlösen');
  var TXT_PLACEHOLDER = T('placeholder', 'Code');
  var TXT_BUTTON = T('button', 'OK');
  var TXT_EMPTY = T('empty', 'Bitte gib einen Code ein.');
  var TXT_MISSING = T('missing', 'Ab %min% legen wir dein Olivenöl dazu — es fehlen noch %missing%.');
  var TXT_READY = T('ready', 'Dein Olivenöl liegt im Warenkorb.');
  var TXT_SAVED = T('saved', 'Code gespeichert. Er wird an der Kasse verrechnet.');
  var TXT_USED = T('used', 'Dein Olivenöl hast du mit einer früheren Bestellung schon bekommen.');
  var TXT_ONE_ONLY = T('one_only', 'Das Olivenöl gibt es einmal pro Bestellung.');
  /* Hinweise, wenn beim Klick auf „Zur Kasse" noch ein Code im Feld steht */
  var TXT_CO_UNKNOWN = T('co_unknown', 'Diesen Code kennen wir nicht. Bitte Schreibweise prüfen — oder erneut auf „Zur Kasse" klicken, um es trotzdem zu versuchen.');
  var TXT_CO_BELOW = T('co_below', 'Ab %min% legen wir dein Olivenöl dazu — es fehlen noch %missing%. Erneut auf „Zur Kasse" klicken, um ohne Geschenk fortzufahren.');

  /* ── Speicher ─────────────────────────────────────────────────────── */

  var KEY_FLAG = 'gm_gift_until';
  var KEY_CODE = 'gm_gift_code';
  var KEY_DECLINED = 'gm_gift_declined';
  var KEY_WAS_IN = 'gm_gift_was_in_cart';
  /* Verbrauchte Codes — ohne Ablauf, damit das Geschenk wirklich nur
     einmal pro Browser rausgeht */
  var KEY_USED = 'gm_gift_used';
  /* Merker fuer die Einloesung: welcher Code liegt gerade im Warenkorb,
     und unter welchem Warenkorb-Token */
  var KEY_PENDING = 'gm_gift_pending';
  var KEY_TOKEN = 'gm_gift_token';

  function store(area, key, value) {
    try {
      if (value === null) { area.removeItem(key); return; }
      area.setItem(key, value);
    } catch (e) { /* Speicher gesperrt — Skript bleibt still */ }
  }
  function read(area, key) {
    try { return area.getItem(key); } catch (e) { return null; }
  }

  /* Code oder URL-Wert einer Aktion zuordnen. '1' bleibt aus
     Kompatibilitaetsgruenden die erste Aktion. */
  function findCampaign(value) {
    if (!value) return null;
    var v = String(value).toLowerCase();
    if (v === '1') return CAMPAIGNS[0];
    for (var i = 0; i < CAMPAIGNS.length; i++) {
      if (CAMPAIGNS[i].code.toLowerCase() === v) return CAMPAIGNS[i];
    }
    return null;
  }

  function arm(campaign) {
    var days = campaign.days || FLAG_DAYS;
    store(localStorage, KEY_FLAG, String(Date.now() + days * 864e5));
    store(localStorage, KEY_CODE, campaign.code);
    store(sessionStorage, KEY_DECLINED, null);
  }

  /* ── Einmal pro Kunde ──────────────────────────────────────────────
     Die Liste der bereits eingeloesten Codes laeuft nicht ab. Sie haengt
     am Browser, nicht am Kundenkonto — mehr laesst sich vom Shop aus
     nicht machen. Wer den Browser wechselt oder die Daten loescht,
     bekommt das Geschenk erneut. Fuer den Zweck reicht das: es
     verhindert das versehentliche Dauergeschenk beim Stammkunden. */
  function usedList() {
    var raw = read(localStorage, KEY_USED) || '';
    return raw ? raw.split(',') : [];
  }
  function isUsed(code) {
    return usedList().indexOf(String(code).toUpperCase()) !== -1;
  }
  function markUsed(code) {
    if (!code) return;
    var c = String(code).toUpperCase();
    var list = usedList();
    if (list.indexOf(c) === -1) {
      list.push(c);
      store(localStorage, KEY_USED, list.join(','));
    }
  }

  /* Die gerade gueltige Aktion — oder null */
  function activeCampaign() {
    var until = parseInt(read(localStorage, KEY_FLAG) || '0', 10);
    if (!until || Date.now() > until) return null;
    if (read(sessionStorage, KEY_DECLINED) === '1') return null;
    return findCampaign(read(localStorage, KEY_CODE));
  }

  /* Geschenk der aktiven Aktion, sonst das der ersten */
  function giftId() {
    var c = activeCampaign();
    return c ? c.gift : CAMPAIGNS[0].gift;
  }

  function disarm() {
    store(localStorage, KEY_FLAG, null);
    store(localStorage, KEY_CODE, null);
    store(localStorage, KEY_USED, null);
    store(localStorage, KEY_PENDING, null);
    store(localStorage, KEY_TOKEN, null);
    store(sessionStorage, KEY_DECLINED, null);
    store(sessionStorage, KEY_WAS_IN, null);
  }

  /* ?gm_gift=1 schaltet die Aktion frei, ?gm_gift=0 wieder ab.
     Die Null ist vor allem zum Testen da: Die Freischaltung liegt
     dreißig Tage im Browser, ein „normaler" Besuch im selben Browser
     ist also nach einem Test nicht mehr normal. */
  function armFromUrl() {
    try {
      var value = new URLSearchParams(window.location.search).get('gm_gift');
      if (value === '0') { disarm(); return; }
      var campaign = findCampaign(value);
      if (campaign) arm(campaign);
    } catch (e) { /* ignorieren */ }
  }

  function isArmed() {
    return !!activeCampaign();
  }

  /* ── Warenkorb ────────────────────────────────────────────────────── */

  var busy = false;

  function getCart() {
    return fetch(url('/cart.js'), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; });
  }

  /* Summe der Artikel, die auf die Schwelle einzahlen.
     Ohne das Geschenk und ohne Gutscheine. */
  function eligibleTotal(cart) {
    var sum = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      if (item.variant_id === giftId()) continue;
      if (item.requires_shipping === false) continue;
      sum += (item.original_line_price != null) ? item.original_line_price : item.line_price;
    }
    return sum;
  }

  function giftInCart(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === giftId()) return true;
    }
    return false;
  }

  function giftQty(cart) {
    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].variant_id === giftId()) return cart.items[i].quantity;
    }
    return 0;
  }

  /* ── Menge des Geschenks hart auf 1 begrenzen ──────────────────────
     Das Geschenkprodukt steht auf 0,00 €. Ohne diese Sperre kann jeder
     im Warenkorb auf „+" druecken und beliebig viele Gratisflaschen
     mitbestellen. Die Mengenknoepfe im Drawer und auf der Warenkorb-
     seite kennen den Sonderfall nicht — deshalb wird hier korrigiert,
     nicht dort. Wirkt unabhaengig davon, ob gerade eine Aktion aktiv
     ist: ein einmal eingelegtes Geschenk bleibt begrenzt. */
  var capping = false;

  function capGift() {
    if (capping) return Promise.resolve(false);
    capping = true;
    return getCart().then(function (cart) {
      if (!cart || !cart.items) return false;
      if (giftQty(cart) <= 1) return false;
      return fetch(url('/cart/change.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: String(giftId()), quantity: 1 })
      }).then(function () {
        setNotes(TXT_ONE_ONLY);
        notifyTheme();
        return true;
      });
    }).catch(function () {
      return false;
    }).then(function (changed) {
      capping = false;
      return changed;
    });
  }

  function addGift() {
    return fetch(url('/cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: giftId(), quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok && window.console) {
        console.warn('[gm-gift] Geschenk konnte nicht hinzugefügt werden');
      }
      return r;
    });
  }

  function removeGift() {
    return fetch(url('/cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: String(giftId()), quantity: 0 })
    });
  }

  /* Notiz an der Bestellung — erscheint im Admin unter der Bestellung.
     Schlägt der Aufruf fehl, ist das folgenlos. */
  function tagCart(code) {
    var attributes = {};
    attributes[ATTR_KEY] = code;
    return fetch(url('/cart/update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    }).catch(function () { /* egal */ });
  }

  /* ── Anzeige auffrischen ──────────────────────────────────────────── */

  var KEY_RELOADS = 'gm_gift_reloads';
  var MAX_RELOADS = 2;

  /* Waehrend des Sprungs zur Kasse darf die Seite nicht neu laden */
  var suppressReload = false;

  function reloadOnce() {
    var done = parseInt(read(sessionStorage, KEY_RELOADS) || '0', 10);
    if (done >= MAX_RELOADS) return;
    store(sessionStorage, KEY_RELOADS, String(done + 1));
    window.location.reload();
  }

  /* Liegt die aktuelle Seite auf der Warenkorbseite? Muss den
     Sprachpraefix beruecksichtigen, sonst greift es auf /en/cart nicht. */
  function onCartPage() {
    var path = window.location.pathname;
    if (ROOT && path.indexOf(ROOT) === 0) path = path.slice(ROOT.length);
    return /^\/cart(\/|$)/.test(path);
  }

  function drawerIsOpen() {
    var el = document.getElementById('gm-drawer');
    if (el && el.className && String(el.className).indexOf('open') !== -1) return true;
    /* Rückfalllösung für andere Drawer-Bauarten */
    return !!document.querySelector('.gm-drawer.open, [class*="cart-drawer"].open, cart-drawer[open]');
  }

  /* Nur aufrufen, wenn der Warenkorb wirklich verändert wurde. */
  function notifyTheme() {
    ['cart:refresh', 'cart:updated', 'cart:change'].forEach(function (name) {
      try {
        document.dispatchEvent(new CustomEvent(name, { bubbles: true, detail: { source: 'gm-gift' } }));
      } catch (e) { /* ignorieren */ }
    });

    /* Ist der Drawer offen, zeichnet er sich nach dem Ereignis selbst neu.
       Ein Neuladen würde ihn schließen und wie ein Sprung auf die
       Warenkorbseite wirken — genau das soll nicht passieren. */
    if (drawerIsOpen()) return;

    /* Waehrend des Checkout-Ablaufs nicht neu laden — sonst bricht der
       Sprung zur Kasse mittendrin ab. */
    if (suppressReload) return;

    if (RELOAD_ON_CART_PAGE && onCartPage()) reloadOnce();
  }


  /* Rückmeldung, wenn der Code liegt, die Schwelle aber noch fehlt.
     Ohne sie tippt jemand den Code ein, es passiert scheinbar nichts. */
  function setNotes(text) {
    var notes = document.querySelectorAll('.' + FIELD_CLASS + ' .gm-code-note');
    for (var i = 0; i < notes.length; i++) {
      if (text) {
        notes[i].textContent = text;
        notes[i].className = 'gm-code-note show';
      } else {
        notes[i].className = 'gm-code-note';
      }
    }
  }

  /* Zahlenformat nach Sprache: 26,00 € auf Deutsch, 26.00 € auf Englisch */
  function money(cents) {
    var loc = (GM.locale === 'de' || !GM.locale) ? 'de-DE' : 'en-IE';
    return (cents / 100).toLocaleString(loc, { minimumFractionDigits: 2 }) + ' €';
  }

  /* Platzhalter %min% und %missing% fuellen */
  function fill(tpl, min, missing) {
    return String(tpl).replace('%min%', money(min)).replace('%missing%', money(missing));
  }

  /* ── Kernlogik ────────────────────────────────────────────────────── */

  function sync() {
    var camp = activeCampaign();
    if (busy || !camp) return Promise.resolve();
    busy = true;

    return getCart().then(function (cart) {
      if (!cart || !cart.items) return;

      /* ── Einloesung erkennen ──────────────────────────────────────
         Nach abgeschlossenem Kauf vergibt Shopify ein NEUES Warenkorb-
         Token. Lag das Geschenk im alten Korb und ist das Token jetzt
         ein anderes, gilt der Code als verbraucht.
         Bewusste Ungenauigkeit: Wer den Warenkorb komplett leert und
         Shopify dabei ein neues Token vergibt, verliert den Anspruch
         ebenfalls. Der Fehler geht in die richtige Richtung — lieber
         ein Geschenk zu wenig als dauerhaft eines zu viel. */
      var pending = read(localStorage, KEY_PENDING);
      var lastToken = read(localStorage, KEY_TOKEN);
      if (pending && lastToken && cart.token && cart.token !== lastToken) {
        markUsed(pending);
        store(localStorage, KEY_PENDING, null);
        store(localStorage, KEY_TOKEN, null);
        store(sessionStorage, KEY_WAS_IN, null);
      }

      /* Menge zurechtruecken, bevor irgendetwas anderes passiert */
      if (giftQty(cart) > 1) { return capGift(); }

      var used = isUsed(camp.code);
      var hasGift = giftInCart(cart);
      var total = eligibleTotal(cart);
      var qualifies = total >= camp.threshold;
      var wasIn = read(sessionStorage, KEY_WAS_IN) === '1';

      if (used && !hasGift) {
        setNotes(TXT_USED);
      } else if (qualifies) {
        setNotes(hasGift ? TXT_READY : '');
      } else {
        setNotes(fill(TXT_MISSING, camp.threshold, camp.threshold - total));
      }

      /* Schon eingeloest → nicht noch einmal einlegen */
      if (used && !hasGift) return;

      /* Kunde hat das Geschenk selbst herausgenommen → nicht nachlegen */
      if (wasIn && !hasGift && qualifies) {
        store(sessionStorage, KEY_DECLINED, '1');
        store(sessionStorage, KEY_WAS_IN, null);
        return;
      }

      if (qualifies && !hasGift) {
        return addGift()
          .then(function () { return tagCart(camp.code); })
          .then(function () { return getCart(); })
          .then(function (fresh) {
            store(sessionStorage, KEY_WAS_IN, '1');
            /* Ab jetzt beobachten wir dieses Token — wechselt es, war es
               ein Kauf. */
            store(localStorage, KEY_PENDING, camp.code);
            if (fresh && fresh.token) store(localStorage, KEY_TOKEN, fresh.token);
            notifyTheme();
          });
      }

      if (!qualifies && hasGift) {
        return removeGift().then(function () {
          store(sessionStorage, KEY_WAS_IN, null);
          store(localStorage, KEY_PENDING, null);
          store(localStorage, KEY_TOKEN, null);
          notifyTheme();
        });
      }

      if (hasGift) {
        store(localStorage, KEY_PENDING, camp.code);
        if (cart.token) store(localStorage, KEY_TOKEN, cart.token);
      }

      store(sessionStorage, KEY_WAS_IN, hasGift ? '1' : null);
    }).catch(function () {
      /* Netzwerkfehler: Warenkorb bleibt unverändert */
    }).then(function () {
      busy = false;
    });
  }

  /* ── Eingabefeld für den Rabattcode ───────────────────────────────── */

  var STYLE_ID = 'gm-gift-style';
  var FIELD_CLASS = 'gm-code-box';

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var css = [
      /* Der Block sitzt direkt über dem Checkout-Button und übernimmt
         dessen Breite — deshalb width:100% und border-box. */
      '.' + FIELD_CLASS + '{width:100%;box-sizing:border-box;margin:0 0 10px;',
      'font-family:var(--font-body--family,Montserrat),sans-serif;text-align:left;}',
      '.' + FIELD_CLASS + ' *{box-sizing:border-box;}',

      /* Eingeklappt: nur eine unscheinbare Zeile */
      '.' + FIELD_CLASS + ' .gm-code-toggle{display:inline-block;padding:2px 0;border:none;background:none;',
      'cursor:pointer;font-family:inherit;font-size:13px;font-weight:400;letter-spacing:.02em;',
      'color:#8B6B4A;text-decoration:underline;text-underline-offset:4px;}',
      '.' + FIELD_CLASS + ' .gm-code-toggle:hover{color:#1B1B1B;}',

      /* Ausgeklappt */
      '.' + FIELD_CLASS + ' .gm-code-panel{display:none;margin-top:8px;}',
      '.' + FIELD_CLASS + '.open .gm-code-panel{display:block;}',
      '.' + FIELD_CLASS + '.open .gm-code-toggle{display:none;}',
      '.' + FIELD_CLASS + ' .gm-code-row{display:flex;gap:6px;width:100%;}',
      '.' + FIELD_CLASS + ' input{flex:1 1 auto;min-width:0;width:100%;height:36px;padding:0 10px;',
      'border:.5px solid #D8D5CF;background:transparent;border-radius:0;font-family:inherit;',
      'font-size:16px;font-weight:300;color:#1B1B1B;outline:none;}',
      '.' + FIELD_CLASS + ' input:focus{border-color:#1B1B1B;}',
      '.' + FIELD_CLASS + ' button.gm-code-go{flex:0 0 auto;height:36px;padding:0 14px;border:none;',
      'border-radius:0;background:#1B1B1B;color:#EEEDE9;cursor:pointer;font-family:inherit;',
      'font-size:10px;font-weight:500;letter-spacing:.1em;text-transform:uppercase;transition:background .2s;}',
      '.' + FIELD_CLASS + ' button.gm-code-go:hover{background:#8B6B4A;}',
      '.' + FIELD_CLASS + ' button.gm-code-go:disabled{opacity:.5;cursor:default;}',
      '.' + FIELD_CLASS + ' .gm-code-msg{display:none;margin:6px 0 0;font-size:11px;line-height:1.5;color:#8B3A2F;}',
      '.' + FIELD_CLASS + ' .gm-code-msg.show{display:block;}',

      /* Offene Fassung: eigener Kasten, damit er im Drawer als Eingabe
         erkennbar ist und nicht als beiläufiger Link. Optik bewusst wie
         die Altersbestätigung darunter. */
      '.' + FIELD_CLASS + '.boxed{padding:0;border:none;background:none;}',
      '.' + FIELD_CLASS + ' .gm-code-headline{display:inline;font-size:10px;font-weight:500;',
      'letter-spacing:.1em;text-transform:uppercase;color:#8B6B4A;}',
      '.' + FIELD_CLASS + ' .gm-code-hint{display:inline;font-size:10px;font-weight:300;',
      'letter-spacing:.02em;color:#6B6B67;}',
      '.' + FIELD_CLASS + ' .gm-code-headline + .gm-code-hint::before{content:" · ";}',
      '.' + FIELD_CLASS + ' .gm-code-hint{margin-bottom:0;}',
      '.' + FIELD_CLASS + '.boxed .gm-code-panel{margin-top:6px;}',
      '.' + FIELD_CLASS + ' .gm-code-note{display:none;margin:6px 0 0;font-size:12px;',
      'line-height:1.5;color:#8B6B4A;}',
      '.' + FIELD_CLASS + ' .gm-code-note.show{display:block;}'
    ].join('');
    var el = document.createElement('style');
    el.id = STYLE_ID;
    el.textContent = css;
    document.head.appendChild(el);
  }

  function redeem(input, message, button) {
    var code = (input.value || '').trim();
    if (!code) {
      message.textContent = TXT_EMPTY;
      message.className = 'gm-code-msg show';
      input.focus();
      return;
    }
    button.disabled = true;

    var campaign = findCampaign(code);
    if (campaign) arm(campaign);

    /* Den Code still bei Shopify hinterlegen — der Aufruf setzt die
       Rabattsitzung, ohne dass die Seite gewechselt wird. Existiert der
       Code nicht, bleibt es folgenlos. */
    fetch(url('/discount/' + encodeURIComponent(code)), { credentials: 'same-origin' })
      .catch(function () { /* egal */ })
      .then(function () {
        button.disabled = false;
        if (campaign) {
          /* sync setzt den Hinweis selbst: Fehlbetrag oder Bestätigung */
          return sync();
        }
        setNotes(TXT_SAVED);
      });
  }

  function buildField() {
    var box = document.createElement('div');
    box.className = FIELD_CLASS;

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'gm-code-toggle';
    toggle.textContent = TXT_TOGGLE;

    var headline = document.createElement('span');
    headline.className = 'gm-code-headline';
    headline.textContent = TXT_LABEL;

    var hint = document.createElement('span');
    hint.className = 'gm-code-hint';
    hint.textContent = TXT_HINT;

    var panel = document.createElement('div');
    panel.className = 'gm-code-panel';

    var row = document.createElement('div');
    row.className = 'gm-code-row';

    var input = document.createElement('input');
    input.type = 'text';
    input.placeholder = TXT_PLACEHOLDER;
    input.setAttribute('aria-label', TXT_LABEL);
    input.autocomplete = 'off';

    var go = document.createElement('button');
    go.type = 'button';
    go.className = 'gm-code-go';
    go.textContent = TXT_BUTTON;

    var message = document.createElement('p');
    message.className = 'gm-code-msg';

    toggle.addEventListener('click', function () {
      box.className = FIELD_CLASS + ' open boxed';
      input.focus();
    });
    go.addEventListener('click', function () { redeem(input, message, go); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); redeem(input, message, go); }
    });
    input.addEventListener('input', function () { message.className = 'gm-code-msg'; });

    row.appendChild(input);
    row.appendChild(go);
    panel.appendChild(row);
    panel.appendChild(message);
    var note = document.createElement('p');
    note.className = 'gm-code-note';

    if (FIELD_ALWAYS_OPEN) {
      box.className = FIELD_CLASS + ' open boxed';
      box.appendChild(headline);
      box.appendChild(hint);
    } else {
      box.appendChild(toggle);
    }
    box.appendChild(panel);
    box.appendChild(note);
    return box;
  }

  function mountField() {
    injectStyle();
    /* Direkt VOR den Checkout-Button hängen. Vorher wurde das ganze
       Formular als Anker genommen — dadurch saß das Feld auf der
       Warenkorbseite über der kompletten Seitenbreite. */
    var targets = document.querySelectorAll('a[href*="/checkout"], button[name="checkout"]');
    for (var i = 0; i < targets.length; i++) {
      var anchor = targets[i];
      if (anchor.closest('header, nav')) continue;
      var parent = anchor.parentElement;
      if (!parent) continue;

      /* Schon eingehängt? Nur direkte Kinder prüfen, damit ein Feld
         im Drawer nicht das auf der Seite blockiert. */
      var exists = false;
      for (var k = 0; k < parent.children.length; k++) {
        if (parent.children[k].className &&
            String(parent.children[k].className).indexOf(FIELD_CLASS) !== -1) { exists = true; break; }
      }
      if (exists) continue;

      try { parent.insertBefore(buildField(), anchor); } catch (e) { /* überspringen */ }
    }
    /* Frisch eingehängte Felder brauchen den aktuellen Hinweis */
    if (isArmed()) sync();
  }

  var mountPending = false;
  function scheduleMount() {
    if (mountPending) return;
    mountPending = true;
    setTimeout(function () { mountPending = false; mountField(); }, 150);
  }

  function watchDom() {
    if (!window.MutationObserver) return;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        if (records[i].addedNodes && records[i].addedNodes.length) { scheduleMount(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ── Code beim Klick auf „Zur Kasse" mitnehmen ────────────────────
     Viele Kunden tippen den Code ein und klicken dann direkt auf „Zur
     Kasse", ohne OK. Ohne diesen Abfang ginge der Code verloren — und
     das Geschenk gleich mit.

     Der Listener laeuft in der CAPTURE-Phase. Das ist wichtig: So kommt
     er vor der Altersabfrage dran, die auf beiden Seiten am selben Klick
     haengt. Reihenfolge: Code anwenden → Alter bestaetigen → Checkout.

     Was NICHT geht: direkt auf /discount/CODE?redirect=/checkout
     umleiten. Dann laeuft die Geschenk-Automatik nie, der Rabatt greift,
     das Oel fehlt — genau die Konstellation, die im Checkout die Meldung
     „Rabattcode ist fuer die Artikel in deinem Warenkorb nicht gueltig"
     erzeugt. */

  var CHECKOUT_SEL = 'a[href*="/checkout"], button[name="checkout"]';
  var proceeding = false;   // wir haben den Klick selbst ausgeloest
  var overrideOnce = false; // zweiter Klick faehrt ohne Pruefung fort

  function fieldFor(el) {
    var parent = el.parentElement;
    if (!parent) return null;
    for (var i = 0; i < parent.children.length; i++) {
      var c = parent.children[i];
      if (c.className && String(c.className).indexOf(FIELD_CLASS) !== -1) return c;
    }
    return null;
  }

  function noteIn(box, text) {
    var note = box.querySelector('.gm-code-note');
    if (!note) return;
    note.textContent = text || '';
    note.className = text ? 'gm-code-note show' : 'gm-code-note';
  }

  function proceed(el, input) {
    if (input) input.value = '';
    overrideOnce = false;
    proceeding = true;
    try { el.click(); } catch (e) { /* ignorieren */ }
    setTimeout(function () { proceeding = false; }, 1500);
  }

  function onCheckoutClick(e) {
    if (proceeding) return;
    var el = e.target && e.target.closest ? e.target.closest(CHECKOUT_SEL) : null;
    if (!el || el.closest('header, nav')) return;

    var box = fieldFor(el);
    if (!box) return;
    var input = box.querySelector('input');
    var code = input ? (input.value || '').trim() : '';
    if (!code) return;

    e.preventDefault();
    e.stopPropagation();

    var campaign = findCampaign(code);

    /* Code schon eingeloest: einmal darauf hinweisen, dann weiter */
    if (campaign && isUsed(campaign.code) && !overrideOnce) {
      overrideOnce = true;
      noteIn(box, TXT_USED);
      return;
    }

    /* Unbekannter Code: anhalten. Ob ein beliebiger Shopify-Rabattcode
       gueltig ist, laesst sich vom Shop aus nicht pruefen — deshalb
       faehrt der zweite Klick trotzdem fort. */
    if (!campaign && !overrideOnce && !isOtherCode(code)) {
      overrideOnce = true;
      noteIn(box, TXT_CO_UNKNOWN);
      if (input) input.focus();
      return;
    }

    suppressReload = true;
    if (campaign) arm(campaign);

    fetch(url('/discount/' + encodeURIComponent(code)), { credentials: 'same-origin' })
      .catch(function () { /* egal */ })
      .then(function () { return campaign ? sync() : null; })
      .then(function () {
        if (!campaign || overrideOnce) return null;
        return getCart().then(function (cart) {
          if (!cart || !cart.items) return null;
          var total = eligibleTotal(cart);
          if (total >= campaign.threshold) return null;
          overrideOnce = true;
          noteIn(box, fill(TXT_CO_BELOW, campaign.threshold, campaign.threshold - total));
          return 'stop';
        });
      })
      .catch(function () { return null; })
      .then(function (result) {
        suppressReload = false;
        if (result === 'stop') return;
        proceed(el, input);
      });
  }

  document.addEventListener('click', onCheckoutClick, true);

  /* ── Auslöser ─────────────────────────────────────────────────────── */

  armFromUrl();

  function boot() {
    mountField();
    watchDom();
    capGift();
    if (isArmed()) sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* Nach jeder Warenkorb-Änderung des Themes */
  if (window.fetch) {
    var originalFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var url_ = '';
      try {
        url_ = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      } catch (e) { url_ = ''; }

      return originalFetch.apply(this, args).then(function (response) {
        if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url_)) {
          /* Die Mengensperre laeuft immer — auch ohne aktive Aktion,
             sonst liesse sich ein bereits eingelegtes Geschenk nach
             Ablauf der Aktion beliebig hochzaehlen. */
          setTimeout(capGift, 120);
          if (!busy) setTimeout(sync, 160);
        }
        return response;
      });
    };
  }

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) sync();
  });
})();